import { DataRow } from 'plugins/types';
import { Query } from 'common/graphqlTypes';
import DVActionsButton from 'plugins/deep-visibility/log-details-renderers/DVActionsButton';

import { mitigationActions } from './actions';
import EventActionsExecutor from './EventActionsExecutor';

const ToolbarActionsButton = ({ values, initialData }: { values: DataRow; initialData?: Partial<Query> }) => (
  <DVActionsButton
    actionsExecutor={EventActionsExecutor}
    actionsList={mitigationActions}
    label="Actions"
    values={values}
    initialData={initialData}
  />
);

export default ToolbarActionsButton;
